import React from "react";
import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { brand } from "../../themes/theme";

/**
 * Aviso de metodologia SIEMPRE visible (no tooltip-only): extrapolacion,
 * horizonte temporal distinto, dato sin tasa publicada, etc. Tono neutro
 * (gris), nunca naranja — no es un punto de fuga, es una nota de rigor.
 *
 * @param {string} children - texto del aviso
 * @param {string} label - etiqueta corta opcional (p.ej. "Sin dato")
 */
function CaveatNote({ children, label, dense }) {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 0.75,
                px: dense ? 1 : 1.25,
                py: dense ? 0.5 : 0.75,
                borderRadius: 1.5,
                bgcolor: brand.gray50,
                border: "1px solid",
                borderColor: brand.gray200,
            }}
        >
            <InfoOutlinedIcon sx={{ fontSize: 14, color: "text.secondary", flexShrink: 0, mt: "1px" }} />
            <Typography sx={{ fontSize: 11.5, color: "text.secondary", lineHeight: 1.45 }}>
                {label && (
                    <Box component="span" sx={{ fontWeight: 500, color: "text.primary" }}>
                        {label}:{" "}
                    </Box>
                )}
                {children}
            </Typography>
        </Box>
    );
}

export default CaveatNote;
